import type { ICollapsibleDropdownProps } from './collapsible-dropdown.types'
import { CollapsibleDropdownView } from './collapsible-dropdown.view'

export const CollapsibleDropdown = (props: ICollapsibleDropdownProps) => <CollapsibleDropdownView {...props} />
